<template>
  <notification />
</template>

<script>
import Notification from './Notification.vue'

export default {

  components: {
    Notification,
  },
}
</script>
